/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { messagesService } from 'services'

const INITIAL_STATE = {
  content: [],
  contentUnread: [],
  isLoading: true,
  categories: {},
}

const { deleteMessages, getMessages, updateMessages, readAllMessages } = messagesService()

function updateMessageCategories(state) {
  const updatedCategories = {}
  Object.keys(state.categories).forEach(category => {
    updatedCategories[category] = 0
  })

  state.contentUnread.forEach(message => {
    const { category } = message
    const numberOfMessages = updatedCategories[category] || 0
    updatedCategories[category] = numberOfMessages + 1
  })

  state.categories = updatedCategories
}

export const fetchMessages = createAsyncThunk('customer/fetchMessages', async contractId => {
  const { data } = await getMessages(contractId)

  return data
})

export const readMessage = createAsyncThunk('customer/readMessage', async messageId => {
  await updateMessages(messageId)
})

export const readUnreadMessages = createAsyncThunk('customer/readUnreadMessages', async () => {
  await readAllMessages()
})

export const removeMessage = createAsyncThunk('customer/removeMessage', async messageId => {
  await deleteMessages(messageId)
})

export const messagesSlice = createSlice({
  name: 'messages',
  initialState: INITIAL_STATE,
  extraReducers: builder => {
    builder
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.isLoading = false
        state.categories = action.payload.categories
        const { messages } = action.payload

        state.content = messages
        const contentUnread = messages.filter(msg => !msg.visualized)
        state.contentUnread = contentUnread
      })
      .addCase(fetchMessages.rejected, state => {
        state.isLoading = false
        state.content = []
        state.error = true
      })
      .addCase(readMessage.fulfilled, (state, action) => {
        const messageToBeUpdated = state.content.find(msg => msg.id === action.meta.arg)

        if (messageToBeUpdated) {
          messageToBeUpdated.visualized = true
        }

        state.contentUnread = state.contentUnread.filter(msg => msg.id !== action.meta.arg)

        updateMessageCategories(state)
      })
      .addCase(readUnreadMessages.fulfilled, state => {
        const unreadMessages = state.content.filter(msg => !msg.visualized)
        unreadMessages.forEach(message => {
          message.visualized = true
        })

        state.contentUnread = []

        updateMessageCategories(state)
      })
      .addCase(removeMessage.fulfilled, (state, action) => {
        state.content = state.content.filter(msg => msg.id !== action.meta.arg)
        updateMessageCategories(state)
      })
  },
})

export default messagesSlice.reducer
